/*
 * @Author: Teemo Ding
 * @Date: 2021-10-28 16:58:00
 * @LastEditTime: 2022-06-06 16:42:00
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/AuditTrail/Communication/CommunicationList/config.tsx
 */
import { get } from 'lodash';
import { handleOnFormatStoreTimeAndDate } from 'src/tools/tools';
import React from 'react';
import Tooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
//import moment from 'moment';
import { replaceI18nVariables } from '@/src/tools/tools';
import Link from 'src/components/Link/Link';
import { EnumFilterType } from 'src/constrains/Query1/Filter';
import { templateCategoryList } from 'src/pages/Settings/Communication/CommunicationTemplateDetail/config';
import { LogStatus } from 'src/types/common/communication';
import { CommunicationChannelType } from 'src/types/common/communication';
import { maskEmail, maskPhone } from '@/src/tools/mask';
import StatusTag from '../Components/StatusTag';
import { getContactName } from '@/src/pages/AuditTrail/Communication/CommunicationDetail/tool';
import css from './css.module.less';

export const statusText = {
  [LogStatus.Failed]: 'Failed',
  [LogStatus.Pending]: 'Pending',
  [LogStatus.Sent]: 'Sent',
};

const LogStatusMappingKey = {
  [LogStatus.Sent]: 'communication.communicationList_config.sent',
  [LogStatus.Pending]: 'communication.communicationList_config.pending',
  [LogStatus.Failed]: 'communication.communicationList_config.failed',
};

const templateCategoryListAll = (templateCategoryList || []).flatMap(
  (item) => item.children,
);

const filterList = (salesChannelList, gatewayList, { getI18n }) => [
  {
    type: EnumFilterType.MultipleSelection,
    dropdownProps: {
      name: getI18n(
        'communication.communicationList_config.communicationCategory',
      ),
    },
    keyWord: 'categories',
    options: templateCategoryListAll,
  },
  {
    type: EnumFilterType.MultipleSelection,
    dropdownProps: {
      name: getI18n(
        'communication.communicationList_config.communicationGateway',
      ),
    },
    keyWord: 'gatewayUuids',
    options: (gatewayList || []).map((item) => ({
      label: item.name,
      value: item.uuid,
    })),
  },
  {
    type: EnumFilterType.MultipleSelection,
    dropdownProps: { name: getI18n('general.sider.salesChannel') },
    keyWord: 'salesChannelUuids',
    options: salesChannelList.map((item) => ({
      label: item.name,
      value: item.uuid,
    })),
  },

  {
    type: EnumFilterType.MultipleSelection,
    dropdownProps: { name: getI18n('general.status') },
    keyWord: 'statuses',
    options: Object.values(LogStatus).map((item) => ({
      label: getI18n(LogStatusMappingKey[item]),
      value: item,
    })),
  },
];

const breadcrumbData = ({ getI18n }) => [
  {
    url: '',
    name: getI18n('general.sider.home'),
  },
  {
    url: '',
    name: getI18n('communication.communicationList_config.auditTrail'),
  },
  {
    url: '',
    name: getI18n('communication.communicationList.communication'),
  },
];

const columns = (
  timezoneInGMT,
  reportingCurrency,
  disableView,
  { getI18n },
) => [
  {
    title: getI18n('communication.communicationList_config.communicaitonID'),
    dataIndex: 'uuid',
    key: 'uuid',
    default: true,
    optional: false,
    sorter: true,
    className: css.columnClass,
    width: 160,
    childGenerate: (text) => {
      return (
        <NoWrapContainer>
          {disableView ? (
            <Tooltip title={text}>{text}</Tooltip>
          ) : (
            <Link className={css.link} to={`/communication/${text}`}>
              <Tooltip title={text}>{text}</Tooltip>
            </Link>
          )}
        </NoWrapContainer>
      );
    },
  },
  {
    title: getI18n('communication.communicationList_config.contactName'),
    dataIndex: 'contactName',
    default: false,
    optional: true,
    key: 'contactName',
    className: css.columnClass,
    minWidth: 128,
    childGenerate: (text, record) => {
      const {
        customerUuid,
        fullName,
        lastName,
        firstName,
        contactName,
        channelType,
      } = record;
      return (
        <NoWrapContainer>
          <Tooltip title={customerUuid ? fullName : contactName}>
            {getContactName({
              customerUuid,
              fullName,
              lastName,
              firstName,
              isVisible: false,
              contactName,
              channelType,
            })}
          </Tooltip>
        </NoWrapContainer>
      );
    },
  },
  {
    title: getI18n(
      'communication.communicationList_config.communicationchannel',
    ),
    dataIndex: 'channel',
    default: false,
    optional: true,
    key: 'channel',
    className: css.columnClass,
    minWidth: 128,
  },
  {
    title: getI18n(
      'communication.communicationList_config.communicationchannel',
    ),
    dataIndex: 'sentTo',
    default: false,
    optional: true,
    key: 'sentTo',
    className: css.columnClass,
    minWidth: 128,
    childGenerate: (text, record) => {
      const channelType = record?.channelType;
      return (
        <NoWrapContainer>
          <Tooltip title={text}>
            {channelType === CommunicationChannelType.Email
              ? maskEmail(text)
              : maskPhone(text)}
          </Tooltip>
        </NoWrapContainer>
      );
    },
  },
  {
    title: getI18n('communication.communicationList_config.sentby'),
    dataIndex: 'sentBy',
    default: false,
    optional: true,
    key: 'sentBy',
    className: css.columnClass,
    minWidth: 128,
  },
  {
    title: replaceI18nVariables(
      getI18n('communication.communicationList_config.sentDate'),
      timezoneInGMT,
    ),
    dataIndex: 'sentAt',
    default: true,
    optional: true,
    sorter: true,
    key: 'sentAt',
    className: css.columnClass,
    minWidth: 200,
    childGenerate: (text) => {
      const time = text ? handleOnFormatStoreTimeAndDate(text) : '';
      return (
        <NoWrapContainer>
          <Tooltip title={time}>{time}</Tooltip>
        </NoWrapContainer>
      );
    },
  },
  {
    title: getI18n('general.status'),
    dataIndex: 'status',
    default: true,
    optional: true,
    key: 'status',
    className: css.columnClass,
    minWidth: 120,
    textAlign: 'center',
    childGenerate: (text, _, index) => {
      return (
        <StatusTag status={text} label={getI18n(LogStatusMappingKey[text])} />
      );
    },
  },
  {
    title: getI18n('communication.communicationDetails.communicationCategory'),
    dataIndex: 'category',
    default: true,
    optional: true,
    key: 'category',
    className: css.columnClass,
    minWidth: 192,
    childGenerate: (text) => {
      const templateCategoryIndex = templateCategoryListAll.filter(
        (o) => o.value == text,
      );
      return (
        <NoWrapContainer>
          <Tooltip title={get(templateCategoryIndex, ['0', 'label'], '')}>
            {get(templateCategoryIndex, ['0', 'label'], '')}
          </Tooltip>
        </NoWrapContainer>
      );
    },
  },
  {
    title: getI18n('communication.communicationDetails.templateName'),
    dataIndex: 'name',
    default: true,
    optional: true,
    key: 'name',
    className: css.columnClass,
    minWidth: 168,
  },
  {
    title: getI18n('communication.communicationDetails.templateLanguage'),
    dataIndex: 'language',
    default: false,
    optional: true,
    key: 'language',
    className: css.columnClass,
    minWidth: 128,
  },
  {
    title: getI18n('communication.communicationDetails.communicationgateway'),
    dataIndex: 'gatewayName',
    default: true,
    optional: true,
    key: 'gatewayName',
    className: css.columnClass,
    minWidth: 208,
  },
  {
    title: getI18n('communication.communicationList_config.orderID'),
    dataIndex: 'orderID',
    default: false,
    optional: true,
    key: 'orderID',
    className: css.columnClass,
    minWidth: 128,
  },
  {
    title: getI18n('general.sider.salesChannel'),
    dataIndex: 'salesChannel',
    default: false,
    optional: true,
    key: 'salesChannel',
    className: css.columnClass,
    minWidth: 128,
  },
  {
    title: getI18n('communication.communicationList_config.customerDatabase'),
    dataIndex: 'customerDatabase',
    default: false,
    optional: true,
    key: 'customerDatabase',
    className: css.columnClass,
    minWidth: 128,
  },
  {
    title: getI18n('general.remarks'),
    dataIndex: 'remarks',
    default: false,
    optional: true,
    key: 'remarks',
    className: css.columnClass,
    minWidth: 128,
  },
];

export { breadcrumbData, columns, filterList };
